import { ReactNode } from 'react'
import Experiment from '@mc/experiments-react'
import { StickyFooter } from 'components/StickyFooter'

export const PEN_5216_FLAG = 'pen-5216_v1'

interface Pen5216WrapperProps {
  control: ReactNode
}

export const Pen5216Wrapper = ({ control }: Pen5216WrapperProps) => (
  <Experiment
    name={PEN_5216_FLAG}
    control={() => <>{control}</>}
    variant_1={() => <StickyFooter hideConciergeExperiment />}
    track={false}
  />
)
